import { EditDialog } from "../../external/ensolvers-core-frontend-mui/components/EditDialog";
import { DialogPosition } from "../../external/ensolvers-core-frontend-mui/components/Common/DialogPosition";
import Assignation from "../../models/Assignation";
import { SpinnerWrapper } from "../SpinnerWrapper";
import AssignationEditionFields from "./Fields/AssignationEditionFields";
import useAssignationForm from "../../hooks/useAssignationForm";

interface Props {
  externalId: string;
  onClose: (updated: boolean) => void;
}

function AssignationEditDialog({ externalId, onClose }: Props) {
  const { isLoading, instance, showDialog, canSave, handleUpdateAssignation, handleUpdateStartDate, handleUpdateEndDate, handleOnCancel } =
    useAssignationForm({ externalId, onClose });

  return (
    <SpinnerWrapper isLoading={isLoading}>
      <EditDialog<Assignation>
        elementName={"Assignation"}
        dialogPosition={DialogPosition.Center}
        currentInstance={instance}
        newItemDialogOpen={showDialog}
        disableSaveButton={!canSave}
        onUpdate={(assignation) => {
          handleUpdateAssignation(assignation);
        }}
        onCancel={handleOnCancel}
        renderDialogContent={(register, errors, control) => (
          <AssignationEditionFields
            control={control}
            register={register}
            errors={errors}
            onStartDateChange={handleUpdateStartDate}
            onEndDateChange={handleUpdateEndDate}
          />
        )}
        buttonStyles={{}}
        setLastUpdateTimestamp={() => {}}
        setNewInstanceDialogOpen={() => {}}
      />
    </SpinnerWrapper>
  );
}

export default AssignationEditDialog;
